(function(scope){
  'use strict';
  function active(policy,context,engine,config,at){
    if(policy?.enabled!==true||context?.store!==policy.store||String(context.themeId)!==policy.themeId||context.role!=='main')return null;
    if(context.currency!=='BRL')return null;
    const c=engine.activeCampaign(config,at),release=c&&policy.campaigns[c.code];
    return release?.enabled===true&&release.checkoutVerified===true&&/^gid:\/\/shopify\/DiscountAutomaticNode\/\d+$/.test(release.discountId||'')?c:null;
  }
  function finish(value){return ['OURO','PRATA'].includes(value)?value:'';}
  function preferencePayload(value,campaignCode){
    const selected=finish(value);if(!selected)throw new TypeError('Banho inválido');
    if(!/^A[1-6]$/.test(campaignCode||''))throw new TypeError('Ação inválida');
    return {attributes:{elyah_black_banho:selected,elyah_black_preferencia_acao:campaignCode,elyah_black_preferencia_versao:'manual-review-v1'}};
  }
  function clock(response,sent,received){
    const age=Number(response.headers.get('Age')||0),date=Date.parse(response.headers.get('Date')||'');
    if(!response.ok||!Number.isFinite(date)||!Number.isFinite(age)||age<0||age>5||received-sent>10000||received<sent)throw new Error('Horário do servidor indisponível');
    return {now:tick=>date+age*1000+(received-sent)/2+tick-received};
  }
  function preferenceAllowed(policy,context,campaign){
    return Boolean(policy?.enabled===true&&policy.persistPreference===true&&policy.manualGiftApproved===true&&policy.giftMode==='manual_review'&&context?.role==='main'&&context.store===policy.store&&String(context.themeId)===policy.themeId&&campaign);
  }
  function preferenceClient({fetcher,root='/',canWrite=()=>false,campaignCode=()=>'',onChange=()=>{}}){
    let queue=Promise.resolve();
    function save(value){
      const code=campaignCode();
      const payload=preferencePayload(value,code);
      const operation=queue.catch(()=>{}).then(async()=>{
        if(!canWrite()||campaignCode()!==code)throw new Error('Persistência desativada');
        const response=await fetcher(root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(payload)});
        if(!response.ok)throw new Error('Não foi possível salvar a preferência');
        const cart=await response.json();
        if(Object.entries(payload.attributes).some(([key,expected])=>cart.attributes?.[key]!==expected))throw new Error('Preferência não confirmada');
        onChange(cart);return cart;
      });
      queue=operation;return operation;
    }
    return {save,pending:()=>queue};
  }
  scope.ElyahBlackActivation=Object.freeze({active,finish,preferencePayload,preferenceAllowed,clock,preferenceClient});
})(typeof window!=='undefined'?window:globalThis);
